import { useState, ChangeEvent, useEffect  } from 'react';
import {
  BackgroundWrapper,
  Header,
  Body,
} from "./Login.styles"
import { Box, Button as PriButton, Grid, TextField} from "@mui/material"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { LOGIN_VALIDATION_MESSAGES, PWD_MIN_LENGTH, COMMON_REGEX } from '../../constants/loginConstants'
import { useUserLogin, usePasswordlessLogin, useLoginWithTempPassword, useGetLoginMode, useForgotPassword, useValidateForgotPassword, useSsoValidateEmail, useResetPassword} from "../../hooks/Users"
import { openInvoices,selectLGInternalUser } from '../../activeScreenSlice';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import StandardAuth from '../../components/StandardAuth/StandardAuth';
import ForgotPassword from '../../components/ForgotPassword/ForgotPassword';
import ForgotPasswordVerify from '../../components/ForgotPassword/ForgotPasswordVerify';
import PasswordlessAuth from '../../components/PasswordlessAuth/PasswordlessAuth';
import PasswordlessVerify from '../../components/PasswordlessAuth/PasswordlessVerify';
import { useAuth } from '../../components/AuthContext/AuthContext';
import useShowError from "../../hooks/useShowError";
import { showToast } from "../../toastSlice";
import ResetPassword from "../../components/ResetPassword/ResetPassword";

export interface LoginRequest {
  username?: string;
  email?: string;
  password: string;
}

type FieldErrors = Partial<Record<keyof LoginRequest, string>>;
export default function Login() {
  const dispatch = useAppDispatch()
  const LGInternalUser = useAppSelector(selectLGInternalUser);
  const [fields, setFields] = useState({ username: "", password: "" });
  const [pwdLessFields, setPwdLessFields] = useState({ email: "", password: ""});
  const [forgotPwdFields, setForgotPwdFields] = useState({ email: "", password: ""});
  const [errors, setErrors] = useState<any>({});
  const [forgotPwdFlag, setForgotPwdFlag] = useState<boolean>(false);
  const [forgotPwdP2Flag, setForgotPwdP2Flag] = useState<boolean>(false);
  const [ssoEmail, setSsoEmail] = useState("");
  const [pwdLessP2, setPwdLessP2] = useState<boolean>(false);
  const userLoginMutation = useUserLogin();
  const useForgotPwdSubmitMutation = useForgotPassword();
  const userPwdLessLoginMutation = usePasswordlessLogin();
  const tempPwdLogin = useLoginWithTempPassword();
  const ssoValidateEmail = useSsoValidateEmail();
  const loginMode = useGetLoginMode();
  const useForgotPwdValidation = useValidateForgotPassword();
  const [isDisabled, setIsDisabled] = useState(false);
  const [timer, setTimer] = useState(0);
  const { setAuthToken, setSessionTime } = useAuth();
  const [ resetPwd, setResetPwd ] = useState(false); 
  const [resetPwdFields, setResetPwdFields] = useState({ currPwd: "", newPwd: "", confNewPwd: ""});
  const [userId, setUserId] = useState("");
  const showError = useShowError()
  const resetPwdMutation = useResetPassword();
  
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setFields({ ...fields, [e.target.name]: e.target.value });
  };

  const handlePwdLessChange = (e: ChangeEvent<HTMLInputElement>) => {
    setPwdLessFields({ ...pwdLessFields, [e.target.name]: e.target.value });
  };

  const handleForgotPwdChange = (e: ChangeEvent<HTMLInputElement>) => {
    setForgotPwdFields({ ...forgotPwdFields, [e.target.name]: e.target.value });
  };

  
  const validate = () => {
    const errs:FieldErrors = {};
    const errsReset: any = {};
    if (resetPwd) {
      if (!resetPwdFields.currPwd) {errsReset.currPwd = LOGIN_VALIDATION_MESSAGES.PWD_REQUIRED;}
      else if(resetPwdFields.currPwd.trim().length < PWD_MIN_LENGTH) {errsReset.currPwd = LOGIN_VALIDATION_MESSAGES.PWD_MINLENGTH}
      if (!resetPwdFields.newPwd) {errsReset.newPwd = LOGIN_VALIDATION_MESSAGES.PWD_REQUIRED;}
      else if(resetPwdFields.newPwd.trim().length < PWD_MIN_LENGTH) {errsReset.newPwd = LOGIN_VALIDATION_MESSAGES.PWD_MINLENGTH}
      if (!resetPwdFields.confNewPwd) {errsReset.confPwd = LOGIN_VALIDATION_MESSAGES.PWD_REQUIRED;}
      else if(resetPwdFields.confNewPwd.trim().length < PWD_MIN_LENGTH) {errsReset.confPwd = LOGIN_VALIDATION_MESSAGES.PWD_MINLENGTH}
      else if(resetPwdFields.confNewPwd !== resetPwdFields.newPwd) {errsReset.confPwd = LOGIN_VALIDATION_MESSAGES.NO_MATCH}
      setErrors(errsReset);
      return Object.keys(errsReset).length === 0;
    } else if(isStandardAuth || isLdapAuth) {
      if(forgotPwdFlag) {
        if(!forgotPwdFields.email) {
          errs.email = LOGIN_VALIDATION_MESSAGES.EMAIL_REQUIRED;
        } else if (!COMMON_REGEX.EMAIL.test(forgotPwdFields.email)) {
          errs.email = LOGIN_VALIDATION_MESSAGES.INVALID_EMAIL;
        } else if (forgotPwdFields.email.trim().length > 50) {
          errs.email = LOGIN_VALIDATION_MESSAGES.MAX_50;
        } else if(forgotPwdP2Flag && !forgotPwdFields.password) {errs.password = LOGIN_VALIDATION_MESSAGES.PWD_REQUIRED;}
      } else {
        if (!fields.username) {
          errs.username = LOGIN_VALIDATION_MESSAGES.EMAIL_REQUIRED;
        } else if (!COMMON_REGEX.EMAIL.test(fields.username)) {
          errs.username = LOGIN_VALIDATION_MESSAGES.INVALID_EMAIL;
        } else if (fields.username.trim().length > 50) {
          errs.username = LOGIN_VALIDATION_MESSAGES.MAX_50;
        }
        if (!fields.password) {errs.password = LOGIN_VALIDATION_MESSAGES.PWD_REQUIRED;}
        else if(fields.password.trim().length < PWD_MIN_LENGTH) {errs.password = LOGIN_VALIDATION_MESSAGES.PWD_MINLENGTH}
      }
      setErrors(errs);
      return Object.keys(errs).length === 0;
    }
    else if(isPwdLessAuth){
      if (!pwdLessFields.email) {
        errs.email = LOGIN_VALIDATION_MESSAGES.EMAIL_REQUIRED;
      } else if (!COMMON_REGEX.EMAIL.test(pwdLessFields.email)) {
        errs.email = LOGIN_VALIDATION_MESSAGES.INVALID_EMAIL;
      } else if (pwdLessFields.email.trim().length > 50) {
        errs.email = LOGIN_VALIDATION_MESSAGES.MAX_50;
      } else if(pwdLessP2 && !pwdLessFields.password) {errs.password = LOGIN_VALIDATION_MESSAGES.PWD_REQUIRED;}
      setErrors(errs);
      return Object.keys(errs).length === 0;
    }
    else if(isSsoSaml || isSsoOauth) {
      if(!ssoEmail) {
        errs.email = LOGIN_VALIDATION_MESSAGES.EMAIL_REQUIRED;
      } else if (!COMMON_REGEX.EMAIL.test(ssoEmail)) {
        errs.email = LOGIN_VALIDATION_MESSAGES.INVALID_EMAIL;
      } else if (ssoEmail.trim().length > 50) {
        errs.email = LOGIN_VALIDATION_MESSAGES.MAX_50;
      }
      setErrors(errs);
      return Object.keys(errs).length === 0;
    }
  }; 

  const onResetPwdSubmit = () => {
    if (validate()) {
      resetPwdMutation.mutate({
          user_id: parseInt(userId),
          old_password: resetPwdFields.currPwd,
          new_password: resetPwdFields.newPwd,
          confirm_new_password: resetPwdFields.confNewPwd
      }, {
          onSuccess: () => {
            setResetPwd(false);
            setFields({ ...fields, password: ''})
            showToast("Your password has been successfully reset. Please proceed to log in.")
          },
          onError: (error:any) => {
            const detail = error?.body?.detail || error.message || "Unknown error";
            showError(`Login attempt unsuccessful: ${detail}`)
          }
      })
    }
  }


  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      if(forgotPwdP2Flag) {
        useForgotPwdValidation.mutate({email: forgotPwdFields.email, password: forgotPwdFields.password},
        {
          onSuccess: (response) => {
            setAuthToken(response.access_token);
            setSessionTime(response.session_inactive_timeout_minutes);
            localStorage.setItem("expiration", response.token_expiry);
            setForgotPwdP2Flag(false);
            dispatch(openInvoices())
          },
        });
      } else if(forgotPwdFlag) {
         useForgotPwdSubmitMutation.mutate({email: forgotPwdFields.email},
        {
          onSuccess: () => {
            setForgotPwdP2Flag(true);
          },
        });
      }
      else {
        userLoginMutation.mutate({email: fields.username, password: fields.password},
        {
          onSuccess: (response) => {
            //Redirect to /
            if(response?.reset_password) {
              setResetPwd(true);
              setUserId(response?.user_id);
            } else {
              setAuthToken(response.access_token);
              setSessionTime(response.session_inactive_timeout_minutes);
              localStorage.setItem("expiration", response.token_expiry)
              dispatch(openInvoices())
            }
            
          },
        });
      }
    }
  };

  const handlePwdLessSubmit = (e) => {
    e.preventDefault();
    if (!pwdLessP2 && validate()) {
      userPwdLessLoginMutation.mutate({email: pwdLessFields.email,LGInternalUser},
      {
        onSuccess: () => {
          setPwdLessP2(true);
        },
      });
    } else if(pwdLessP2 && validate()) {
      tempPwdLogin.mutate({email: pwdLessFields.email, password: pwdLessFields.password},
      {
        onSuccess: (response) => {
          setAuthToken(response.access_token);
          setSessionTime(response.session_inactive_timeout_minutes);
          localStorage.setItem("expiration", response.token_expiry)
          setPwdLessP2(false);
          dispatch(openInvoices())
        },
      });
    }
  };

  const ssoLoginHandler = () => {
    if (validate()) {
      ssoValidateEmail.mutate({email: ssoEmail}, {
        onSuccess: (response) => {
          if(response.status === "success") {
            window.location.href = `${import.meta.env.VITE_API_ENDPOINT}/users/${isSsoSaml ? 'sso' : isSsoOauth ? 'oauth' : '' }/login`;
          } else {
            showError(`Login attempt unsuccessful: ${response.message}. Please contact the administrator.`)
          }
        }
      });
    }
  }

  const handleForgotPwEmailChange = (e: ChangeEvent<HTMLInputElement>) => {
    setForgotPwdFields({ ...forgotPwdFields, [e.target.name]: e.target.value });
  };

  const handleSsoEmailChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSsoEmail(e.target.value);
  };

  const handleForgotPwdClick = () => {
    setForgotPwdFlag((val) => !val)
  }

  const handleBackClick = () => {
    if(forgotPwdP2Flag) {
      setForgotPwdP2Flag(false);
      setTimer(0);
      setIsDisabled(false);
    }else if(isStandardAuth) {
      setForgotPwdFlag(false);
    }else if(isPwdLessAuth){
      setPwdLessP2(false);
      setTimer(0);
      setIsDisabled(false);
    }
  }

   useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0 && isDisabled) {
      setIsDisabled(false);
    }

    return () => clearInterval(interval);
  }, [timer, isDisabled]);

  const handleCancelClick = () => {
    setResetPwd(false);
  }

  const handleCurrentPwdChange = (e) => {
    setResetPwdFields({ ...resetPwdFields, [e.target.name]: e.target.value });
  }

  const isStandardAuth = !LGInternalUser && loginMode?.data?.name === "standard_authentication";
  const isSsoSaml = !LGInternalUser &&  loginMode?.data?.name === "sso_saml";
  const isSsoOauth = !LGInternalUser &&  loginMode?.data?.name === "sso_oauth";
  const isLdapAuth = !LGInternalUser && loginMode?.data?.name === "ldap_authentication";
  const isPwdLessAuth = LGInternalUser ? true : loginMode?.data?.name === "passwordless_authentication";

  const resendRequest= () => {
    userPwdLessLoginMutation.mutate({email: pwdLessFields.email,LGInternalUser});
    setTimer(60);
    setIsDisabled(true);
  }

  const resendForgotRequest = () => {
    useForgotPwdSubmitMutation.mutate({email: forgotPwdFields.email});
    setTimer(60);
    setIsDisabled(true);
  }

  return (
    <BackgroundWrapper>
      <Box
        component="form"
        onSubmit={isPwdLessAuth ? handlePwdLessSubmit : handleSubmit}
        sx={{ margin: '0 auto', width: resetPwd? '880px': '440px',}}
        noValidate
      >
        {
          ((isPwdLessAuth && pwdLessP2) || (isStandardAuth && forgotPwdFlag)) && 
          <PriButton 
            variant="outlined" 
            onClick={handleBackClick}
            sx={{
                  textTransform: 'none',
                  position: "absolute",
                  left: 30,
                  top: 100
              }} 
            startIcon={<ArrowBackOutlinedIcon />}>
            Back
          </PriButton>
        }
        { !resetPwd && <><Header sx={{marginTop: '40px'}}>Welcome to Arrow</Header>
        <Body>
          Fast and reliable invoice processing, giving businesses time and space
          to focus on the other things that matter...
        </Body></>}
        {
          (isStandardAuth || isLdapAuth) && !forgotPwdFlag && !resetPwd &&
          <StandardAuth  username={fields.username} password={fields.password} handleChange={handleChange} errorsUsername={errors.username} errorsPwd={errors.password} handleForgotPwdClick={handleForgotPwdClick} isStandardAuth={isStandardAuth} loginMutation={userLoginMutation}/>
        }
        {
          isStandardAuth && forgotPwdFlag && !forgotPwdP2Flag && 
          <ForgotPassword email={forgotPwdFields.email} handleForgotPwEmailChange={handleForgotPwEmailChange} errorsEmail={errors.email} useForgotPwdSubmitMutation={useForgotPwdSubmitMutation}/>
        }
        {
          isStandardAuth && forgotPwdFlag && forgotPwdP2Flag && 
            <ForgotPasswordVerify email={forgotPwdFields.email} password={forgotPwdFields.password} errPwd={errors.password} handleForgotPwEmailChange={handleForgotPwEmailChange} resendForgtRequest={resendForgotRequest} handleForgotPwdChange={handleForgotPwdChange} isDisabled={isDisabled} timer={timer} useForgotPwdSubmitMutation={useForgotPwdSubmitMutation} useForgotPwdValidation={useForgotPwdValidation}/>
        }
        {
          isPwdLessAuth && !pwdLessP2 && 
          <PasswordlessAuth email={pwdLessFields.email} handlePwdLessChange={handlePwdLessChange} errorsEmail={errors.email} userPwdLessLoginMutation={userPwdLessLoginMutation}/>
        }

        {
          isPwdLessAuth && pwdLessP2 && 
          <PasswordlessVerify email={pwdLessFields.email} password={pwdLessFields.password} errorsEmail={errors.email} errorsPwd={errors.password} handlePwdLessChange={handlePwdLessChange} resendRequest={resendRequest} isDisabled={isDisabled} timer={timer} userPwdLessLoginMutation={userPwdLessLoginMutation} useLoginWithTempPassword={tempPwdLogin}/>
        }
        {
          resetPwd && <ResetPassword password={resetPwdFields.currPwd} handleCurPwdChange={handleCurrentPwdChange} newPassword={resetPwdFields.newPwd} handleNewPwdChange={handleCurrentPwdChange} confPassword={resetPwdFields.confNewPwd} handleConfirmPwdChange={handleCurrentPwdChange} resetPwdMutation={onResetPwdSubmit } handleCancelClick={handleCancelClick} errCurrPwd={errors.currPwd} errNewPwd={errors.newPwd} errConfPwd={errors.confPwd} />
        }
        {
          (isSsoSaml || isSsoOauth) && <Box  sx={{width: '75%', margin: '0 auto',  minHeight: `calc(100vh - 220px)`}}>
              <Body sx={{fontSize: '20px', fontWeight: 800, color: "#111", lineHeight: '24px',}}>
                  Sign in using the email address associated with your SSO registration.
              </Body>
              <Grid sx={{ marginTop: '20px',}}>
                <TextField
                    label={!ssoEmail ? "Email address" : undefined}
                    value={ssoEmail}
                    name="ssoEmail"
                    onChange={handleSsoEmailChange}
                    fullWidth
                    required
                    error={!!errors.email}
                    helperText={errors.email}
                    InputProps={{
                      sx: {
                        backgroundColor: 'white'
                      }
                    }}
                />
              </Grid>
              <Grid sx={{ marginTop: '20px', }}>
                <PriButton
                  variant="contained"
                  onClick={ssoLoginHandler}
                  sx={{
                    textTransform: 'none',
                    width: '100%',
                    margin: '10px 0 45%'
                }}
              >
                Login
              </PriButton>
            </Grid>
          </Box>
        }
        <Box
          sx={{
            color: "var(--brand-default-color)",
            fontSize: "12px",
            lineHeight: "16px",
            fontWeight: 400,
            textAlign: "center",
            margin: '40px auto 20px',
            position: "relative",
            bottom: "0px",
            left: "50%",
            transform: "translateX(-50%)",
            
          }}
        >
          Powered by Liberty Blume&nbsp;<sup
            style={{
              fontSize: "0.5em",
              verticalAlign: "top",
            }}
          >
            ®
          </sup>
        </Box>
      </Box>
    </BackgroundWrapper>
  )
}
